import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const cardRecipeFn = /* @__PURE__ */ createRecipe('card', {
  "variant": "primary"
}, [
  {
    "variant": "primary",
    "boxShadow": "displayBox",
    "css": {
      "boxShadow": "0em 0em 0.25rem 0em {colors.gray.secondary}"
    }
  }
])

const cardRecipeVariantMap = {
  "variant": [
    "primary",
    "secondary",
    "tertiary"
  ],
  "boxShadow": [
    "displayBox"
  ]
}

const cardRecipeVariantKeys = Object.keys(cardRecipeVariantMap)

export const cardRecipe = /* @__PURE__ */ Object.assign(memo(cardRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'cardRecipe',
  __getCompoundVariantCss__: cardRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: cardRecipeVariantKeys,
  variantMap: cardRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, cardRecipeVariantKeys)
  },
  getVariantProps: cardRecipeFn.getVariantProps,
})